module.exports = __webpack_public_path__ + "static/media/bcom-business_LR.828e87b1.jpg";